export default "__VITE_ASSET__BxG8t4KR__"